import Vue from 'vue';
import Router from 'vue-router';

// children router

// lazyload Components
const RootView = () => import('Pages/RootView.vue');
const Header = () => import('Pages/MainModule/Header.vue');
const SideMenu = () => import('Pages/MainModule/SideMenu.vue');
const MainView = () => import('Pages/MainModule/MainView.vue');
const Footer = () => import('Pages/MainModule/Footer.vue');
const HomeView = () => import('Pages/HomeModule/HomeView.vue');
const AboutView = () => import('Pages/AboutModule/AboutView.vue');
const NewsView = () => import('Pages/NewsModule/NewsView.vue');
const ArtView = () => import('Pages/ArtModule/ArtView.vue');
const LifeView = () => import('Pages/LifeModule/LifeView.vue');
const ServiceView = () => import('Pages/ServiceModule/ServiceView.vue');

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: RootView,
      children: [
        {
          path: '/',
          components: {
            default: MainView,
            header: Header,
            sidemenu: SideMenu,
          },
          children: [
            {
              path: '/',
              components: {
                default: HomeView,
                footer: Footer,
              },
            },
            {
              path: 'home',
              components: {
                default: HomeView,
                footer: Footer,
              },
            },
            {
              path: 'about',
              components: {
                default: AboutView,
                footer: Footer,
              },
            },
            {
              path: 'news',
              components: {
                default: NewsView,
                footer: Footer,
              },
            },
            {
              path: 'art',
              components: {
                default: ArtView,
                footer: Footer,
              },
            },
            {
              path: 'life',
              components: {
                default: LifeView,
                footer: Footer,
              },
            },
            {
              path: 'service',
              components: {
                default: ServiceView,
                footer: Footer,
              },
            },
          ],
        },
      ],
    },
    { path: '*', redirect: '/' },
  ],
});
